<template>
  <Modal class="tablet-h:max-w-[500px]!">
    <Modal.Title>Transaction history</Modal.Title>
    <Modal.Body>
      <div class="mb-[14px]">
        History of your copyright since it was created.
      </div>
      <TransactionCard
        v-for="(transaction, index) in transactions"
        :key="index"
        :transaction="transaction"
        class="mb-2.5 last:mb-0"
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" @click="close()">Done</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import type { Transaction } from '@/shared/graphql/legacy/generated'
import TransactionCard from '@/features/billing/components/TransactionCard.vue'

defineProps<{
  transactions: Transaction[]
}>()

const { close } = useModal()
</script>
